import { render, staticRenderFns } from "./vertical-tabs.vue?vue&type=template&id=f90f6408&"
import script from "./vertical-tabs.vue?vue&type=script&lang=js&"
export * from "./vertical-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab})
